import { useMemo } from 'react';
import { useStorage } from '../../hooks/use-storage';

function useWelcomeManager() {
  const { language } = useStorage();

  const welcomeKey = useMemo(() => `welcome=${language.tag}`, [language]);

  return {
    welcomeKey,
  };
}

export { useWelcomeManager };
